import { decode as base64_decode, encode as base64_encode } from "base-64";
import { postApi, baseURL } from "../components/Utility";
import {
  action,
  makeObservable,
  observable,
} from "mobx";
import { message } from "antd";
import config from "../config";

class DriverLoginReportStore {
  total = 0;
  driverLoginStore = [];
  totalDriverArray=[]
  getDrivers = [];
  loading=false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      driverLoginStore: observable,
      total: observable,
      totalDriverArray:observable,
      loading:observable,
      loadData: action,
      getDriversByCompanyId: action,
      totalDriverReport:action,
    });
    this.rootStore = rootStore;
  }

  async loadData({
    companyId,
    driverId,
    fromDate,
    toDate,
    offset,
    limit,
    pageNo,
  }) {
    // console.log("vehicle list");
    var postData = {
      companyId: companyId,
      driverName: driverId,
      fromDate: fromDate,
      toDate: toDate,
      offset: offset,
      limit: limit,
      page: pageNo,
    };
    this.loading = true;

     if (config.pythonReport === 1) {
      var response = await postApi
        .getClient("report")
        .post("/driver_report/driverLogin", postData);
      this.total = parseInt(response?.data?.data?.TotalCount);
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi
        .getClient()
        .post("index.php?c=driver&a=driverLogin", "postData=" + base64Input);
    }

    // console.log(response?.data?.data?.driverLoginReport);
    this.driverLoginStore = response?.data?.data?.driverLoginReport;
    this.total = parseInt(response?.data?.data?.TotalCount);
    this.loading = false;

  }

  async getDriversByCompanyId({ companyId }) {
    var postData = { companyId: companyId };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=driver&a=getDriverData", "postData=" + base64Input);
    console.log(response, "post");
    this.getDrivers = response?.data?.data;
    return response?.data?.data;
  }

  async totalDriverReport({
    companyId,
    driverId,
    fromDate,
    toDate,
    
  }) {
    this.loading=true
    // console.log("vehicletotalPerformance")
    var postData = {
      companyId: companyId,
      driverName: driverId,
      fromDate: fromDate,
      toDate: toDate,
      total: true
    };

    if (config.pythonReport === 1) {
      var response = await postApi
        .getClient("report")
        .post("/driver_report/driverLogin", postData);
      this.totalDriverArray = response?.data?.data?.driverLoginReport;
    }else{
        const base64Input = await base64_encode(JSON.stringify(postData));
        var response = await postApi.getClient().post("index.php?c=driver&a=driverTotal", "postData="+base64Input);   
        this.totalDriverArray = response?.data?.data
    }
   
    // this.total = parseInt(response?.data?.data?.TotalCount);
    this.loading=false;
  }

  async exportExcel(getData) {

    if (config.pythonReport === 1) {

      getData = { ...getData, language: "english" };
      
      try {
        await postApi
          .getClient("report")
          .post("/driver_report/driverLogin/download/excel", getData, {
            responseType: "blob",
          });
        this.pythonReportMessage = true;

      } catch (error) {
        this.pythonReportErrorMessage = false;
        message.error("Failed to download the report. Please try again.");
      }

    } else {
        let lang = "english";
        window.location.href =
          baseURL +
          "index.php?c=driver&a=exportDriverLoginExcel&cid=" +
          getData.companyId +
          "&userId=" +
          getData.userId +
          "&did=" +
          getData.DriverId +
          "&fD=" +
          getData.fromDate +
          "&tD=" +
          getData.toDate +
          "&colList=" +
          getData.colList;
    }
  }
  async exportpdf(getData) {

    if (config.pythonReport === 1) {

      getData = { ...getData, language: "english" };
      try {
        await postApi
          .getClient("report")
          .post("/driver_report/driverLogin/download/pdf", getData, {
            responseType: "blob",
          });
        this.pythonReportMessage = true;
    
      } catch (error) {
        this.pythonReportErrorMessage = false;
        message.error("Failed to download the report. Please try again.");
      }
    } else {

        let lang = "english";
        window.location.href =
          baseURL +
          "index.php?c=driver&a=exportDriverLoginPdf&cid=" +
          getData.companyId +
          "&userId=" +
          getData.userId +
          "&did=" +
          getData.DriverId +
          "&fD=" +
          getData.fromDate +
          "&tD=" +
          getData.toDate +
          "&colList=" +
          getData.colList;
    }
  }
  async exportcsv(getData) {
    window.location.href =
      baseURL +
      "index.php?c=driver&a=exportDriverLoginCsv&cid=" +
      getData.companyId +
      "&userId=" +
      getData.userId +
      "&did=" +
      getData.DriverId +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList;
  }
  async exportxml(getData) {
    window.location.href =
      baseURL +
      "index.php?c=driver&a=exportDriverLoginXml&cid=" +
      getData.companyId +
      "&userId=" +
      getData.userId +
      "&did=" +
      getData.DriverId +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList;
  }
}

export default DriverLoginReportStore;
